export enum ParseState {
  Begin = 1,
  FieldDefinitions = 2,
  Components = 3,
  Messages = 4,
  End = 5
}
